import { HttpService } from '@/infra/http'

export type TCreatePessoaJuridicaData = {
  cnpj: string
  razaoSocial: string
  email: string
  telefone: {
    numero: string
    origem: 'Brasil' | 'Internacional'
    principal: boolean
  }
}

export type TCreateContaResponse = {
  id: string
  message: string
  date: string
}

export class CriarPessoaJuridica extends HttpService {
  execute = async (pessoaJuridica: TCreatePessoaJuridicaData) => {
    const response = await this.http.post<TCreateContaResponse>(`/api/v2/Conta`, pessoaJuridica)
    return response.data
  }
}
